// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  agentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  agents: 'da6a4370f1cfadfa614a982059930e6c',
  allProjects: '44f082cbccdf04b6fab74ca6e79b17ab',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '21e2a589930880b02849c0d5cd1784c6',
  banners: '79fc14e7a2d33627218e2a7c54281ba3',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRatings: '79165c6e4378ec4106df9d0e76daeb3e',
  bidRestrictions: 'adb784b5a44d9bbed98a52e15aca37be',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: 'bb76718590348ff00c21ff1f9a334188',
  billingAgreements: '36ed5ee1881c169b6c51f82941bd6f82',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartItems: '0024876dd5b5c6bd893f804887ba50b7',
  carts: '22516f581ba71b60c5e67a3870e4eb2b',
  categoryPageContent: 'f7f6e760b00353b70abd6df550140d96',
  categoryPageViewUsers: '2914a0a02cbcd5dea1fdbd16052f19f4',
  certifications: '43fd8862311f73a91a22f2e897799065',
  contacts: '10d58afb59c8d456fdf5926bca206184',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestComments: '6e9d4f72d9870a4c7f46e6da3c05a1d4',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '51d116218f1a7f0dc626ec43adf4e1c7',
  contestEntryMessages: 'c7d4151e027c1ac46f8632d003e46eb6',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: 'c43f3df6657d87978a841360838e64d2',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: '21cc7667d8f9064201d1cb23815c9d56',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestQuickviewEntries: '8bc5cb5bac06be6c4b034ebd940e92c8',
  contestViewContests: 'e9235ad8ad656671b4bdbe3df446c6ff',
  contestViewEntries: '95b327387ca4155f71df8c2b1491ff6a',
  contestViewEntryIds: '02fe86a231d7ebfc756543fa1dc8f2b6',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contests: 'f004ead4fd77f488afa194d9a0f1c29c',
  countries: '33e3d762aebe1f0623085e309dd09ee8',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: '47db5a7df92772b22a46b9a35aff6594',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '85dc2b2a2031be813a9643266a4dd010',
  depositPageVars: '10745ad12dfa11c2d7857d8c38cd00ee',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  discoverCollections: 'f3e5816f6210bed2525a5024155dd4ec',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  experiences: '40986fee31964385e45bc33aef538cf7',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  grants: '20ff455821752fb9663d8e5132ecb5cf',
  groupMembers: 'b4b3377732dcb3954dc0f9b54e2fb764',
  groups: '43caf127bc4f37d32d37d59fe924aa25',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: 'd0fc4cd9c09cc18075303cd8968637c3',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  manageViewContestHandovers: '82b33dd2211192cffbf31da389b66fbc',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: 'f9f7d834f45a6f4fcf7a1fa9867bcb94',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: '143cf47582dc93622ae5b43c8a139ec1',
  manageViewPastBids: '4eebf38eb7730e8071a087e690d974cc',
  manageViewPastProjects: '5acb8adb78a0089cff3a289532d243e1',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '5e55af3581868b7b8e293b90768eadb8',
  membershipSubscriptions: '0c4efaf0be704e7d0f20a57f3a6fade5',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '4a03ed6f70c6e69c43377c1555c84e45',
  milestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: '59143449e52559b3dd7e732c6037a2f7',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: '54c55fafb853a751228b1e86bd41f884',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: 'f105907cc84ba0c2fb6cd2f6fac26461',
  onBehalfProjects: '00f7e546a85c98a15afb0d0acfa794da',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: 'f799d42650b7c33019da0f98866b1c05',
  postJobPageFormState: '74da2f15cb0a3db495a0b538cdff9184',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: '47dfe05c3f61b4211b40c5d48ee9b8ee',
  projectBidInfo: 'ab477194db9f73abbaeddc867441c1b3',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingProjects: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeed: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectStats: 'b4df8e5e2ccfc3d08a7e1a0821626e59',
  projectUpgradeFees: '01c1f1a6e0c868ac64b6d4e3fbaa36b9',
  projectViewBidderLocations: 'b2a8f70249fcabcab95f58f8bc29dd4d',
  projectViewBids: '6c1e5f4ed8518e4d36a77080c8b1ec06',
  projectViewProjects: '7cbf1d12c5b7cc965b5fa72d760a4ccf',
  projectViewUsers: '0eaf2f4081a4ecb117f3dff59069826f',
  projects: '86212c433b10b1220180ebf6b6698ddd',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recommendedMembership: '639af6e0ad703937a10cf2ed5a34d11e',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  reviewsSkills: '0fa5a9706cd3dde5679039085018d7de',
  reviews: '327d3865eb1c5b8a9bbe8c917f8682f5',
  searchActiveContests: '9ebb05bdb428656f7c8d1a1be3e10e68',
  searchActiveProjects: '6e9d495196d02c6cee44e5faeaf9a335',
  searchAllProjects: '86212c433b10b1220180ebf6b6698ddd',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '95b327387ca4155f71df8c2b1491ff6a',
  searchContests: '4eecae75511f66bd3a1d7abbad095059',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchKeywordProjects: '376e39365445b24fc572ff1ce797e727',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchThreads: 'ae15f97f2addb674ad5625424d99e907',
  searchUsers: '1b7bcca3bd011506eaf7e046bc07c229',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  showcase: 'a423817f39ff390fb08861528feb0ba6',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: '33cd2c64dafbae9a9d94f85febee0490',
  superuserBids: 'bb76718590348ff00c21ff1f9a334188',
  superuserMessages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  superuserMilestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  superuserProjectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  superuserProjectViewProjects: '7cbf1d12c5b7cc965b5fa72d760a4ccf',
  superuserProjectViewUsers: 'ef9eab2df90af775e0efc304b7fcfe79',
  superuserSearchThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  superuserThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  threadProjects: '416ddec5bd09578814846d275a12c8af',
  threads: 'ae15f97f2addb674ad5625424d99e907',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '978a2c023ab70576f2d3630e89ced002',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  timeTrackingSession: 'afd7dcc3791c3071706c3f11df175ed9',
  toastNotifications: 'c61edbcd53aeb12f9d34575ed28c68a5',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: 'f49d9cf97d9c96227a57a4a3a6d997bf',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: '070f273b6225ae6bc489ef6f57729b0b',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userNps: '4cbf9dfa2ab3c351d16e8489d8977f8d',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: '36c37e6fe4dfd1b3f46b2108585890a0',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: '2738be7c407c765e85647e2124e90bb0',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '1392b14f79f60012b59cee5a9143852e',
  users: 'cf01ceee2748aad120a6bd397a3f487e',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationRequest: 'f9366dfbb548d1eb4b03504af4bc6914',
  violationReports: 'dba92b71477988f2a8017329ccbfe155',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
